<template>
  <v-dialog v-model="rootStore.confirm" persistent>
    <v-card class="modal-confirm">
      <button type="button" v-if="rootStore.confirmIsShowClose" class="close" @click="close()"><img src="@/assets/images/ico_pop_close.png" alt="닫기"></button>
      <v-card-title v-if="rootStore.confirmTitle" v-html="rootStore.confirmTitle"></v-card-title>
      <v-card-text v-html="rootStore.confirmMessage" class="modal-body"></v-card-text>
      <v-card-actions class="modal-footer">
        <button type="button" class="btn cancel" @click="cancel()" v-if="rootStore.confirmCancelBtn">{{ rootStore.confirmCancelBtn }}</button>
		    <button type="button" class="btn okay" @click="okay()" v-if="rootStore.confirmOkayBtn">{{ rootStore.confirmOkayBtn }}</button>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { useRootStore } from '@/stores/useRootStore';

const rootStore = useRootStore();

const close = () => {
  rootStore.resetConfirm();
}

const cancel = () => {
  if (rootStore.confirmCancelFunc) rootStore.confirmCancelFunc();
  close();
}

const okay = () => {
  if (rootStore.confirmOkayFunc) rootStore.confirmOkayFunc();
  close();
}
</script>

<style scoped>
  .v-dialog .v-overlay__content > .v-card, .v-dialog .v-overlay__content > .v-sheet{
    border-radius:3.2rem; 
    overflow: hidden; 
    box-shadow: 0 0 2rem 0 rgba(0,0,0,.25);
  }
  .v-dialog .v-overlay__content > .v-card > .v-card-title{
    display:block; 
    width:100%; 
    padding:6rem 2.4rem 0; 
    font-size:var(--hecto-font-36); 
    color:var(--hecto-black); 
    text-align:center; 
    font-weight:700; 
    border:0;
  }
  .v-dialog .v-overlay__content > .v-card > .v-card-text{
    padding:5rem 3.8rem 2rem; 
    font-size:var(--hecto-font-28); 
    color:var(--hecto-black);
    text-align:center; 
    word-break: keep-all;
    opacity:1;
  }
  .v-dialog .modal-confirm .modal-footer{
    height:auto; 
    padding:2rem 4.8rem 4.8rem; 
    border:0;
  }
  .v-dialog .modal-confirm .modal-footer .btn{
    flex:1;
    height:9.4rem; 
    margin:0; 
    padding:0; 
    border-radius:var(--hecto-radius-16);
    font-weight:500;
    font-size:var(--hecto-font-32);
    line-height: 1.2;
  }
  .v-dialog .modal-confirm .modal-footer .btn+.btn{
    margin-left:1.4rem;
  }
  .v-dialog .modal-confirm .modal-footer .btn.cancel{
    color:var(--hecto-white);
    background-color:var(--hecto-bg-disabled);
  }
  .v-dialog .modal-confirm .modal-footer .btn.okay{
    color:var(--hecto-white);
    background-color:var(--hecto-primary, #305ae4);
  }
  .v-dialog .modal-confirm .modal-footer .btn+.btn{border-left:1px solid rgba(255,255,255,.15);}
  
  .close{
    position: absolute;
    top: 3rem;
    right: 3rem;
    z-index: 1;
  }

  @media screen and (max-width:900px){
    .modal-confirm{width:60rem;}
  }
  @media screen and (max-width:320px){
  }
</style>